export default __webpack_public_path__ + "static/media/SRI VISHNU JEWELLERS.7e8113f6.jpg";